var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 8"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.905,
    height: 4.587,
    x: 0.366,
    y: 1.647,
    fill: "currentColor",
    rx: 0.452,
    transform: "rotate(-45 .366 1.647)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.905,
    height: 4.626,
    fill: "currentColor",
    rx: 0.452,
    transform: "scale(-1 1)rotate(-45 -1.486 9.114)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.905,
    height: 4.587,
    fill: "currentColor",
    rx: 0.452,
    transform: "scale(1 -1)rotate(-45 -7.971 -3.819)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.905,
    height: 4.626,
    x: 6.88,
    y: 6.783,
    fill: "currentColor",
    rx: 0.452,
    transform: "rotate(135 6.88 6.783)"
  })));
};
export default SvgClose;